import "./secureArchitectureSection.css";
import shieldLock from "../../assets/images/shieldLock.png";
import cloudRight from "../../assets/vector/Vector-9.png";

export default function SecureArchitectureSection() {
  return (
    <section className="secure-arch">
      <div className="secure-arch__bg">
        <img
          src={cloudRight}
          className="secure-arch-cloud secure-arch-cloud--right"
          alt='img'
        />
      </div>

      <div className="secure-arch__frame">
        <div className="secure-arch__inner">
          <div className="secure-arch__content">
            <h2 className="secure-arch__title">
              A Secure, Private, and Enterprise-Ready Architecture
            </h2>

            <p className="secure-arch__body">
              Data confidentiality and security are foundational to Ryse.
              Organizations can deploy our system through a fully integrated
              on-premise inference appliance, allowing all data, models, and
              computations to remain entirely within their own infrastructure.
              This provides cloud-level performance with on-premise control —
              ensuring no information ever leaves the environment while
              delivering scalable, production-ready AI workloads.
            </p>
          </div>

          <div className="secure-arch__visual">
            <div className="secure-arch__image-wrapper">
              <img
                src={shieldLock}
                alt="Secure architecture"
                className="secure-arch__image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
